import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

class ClosuresOfCashReceiptsPDF {

    exportPDF = async (data, starterDate, finalDate) => {

        pdfMake.fonts = {
            OpenSans: {
                normal: 'OpenSans-Regular.ttf',
                bold: 'OpenSans-Bold.ttf',
                italics: 'OpenSans-Italic.ttf',
                bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
            },
            Merriweather: {
                normal: 'Merriweather-Regular.ttf',
                bold: 'Merriweather-Bold.ttf',
                italics: 'Merriweather-Italic.ttf',
                bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
            },
            Roboto: {
                normal: 'Roboto-Regular.ttf',
                bold: 'Roboto-Bold.ttf',
                italics: 'Roboto-Italic.ttf',
                bolditalics: 'Roboto-BoldItalic.ttf'
            },
            CantoraOne: {
                bold: 'CantoraOne-Regular.ttf'
            }
        };

        const clinica = JSON.parse(sessionStorage.getItem('clinica'));

        const styles = await this.getStyles();
        const documentDefinition = {
            pageSize: "LEGAL",
            pageOrientation: 'landscape',
            styles: styles,
            content: [
                {
                    columns: [
                        {
                            width: 315,
                            columns: [
                                {
                                    image: await this.getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + clinica.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                                    fit: [180, 90],
                                },
                            ],
                        },
                        {
                            width: 315,
                            fontSize: 10,
                            text: [
                                {
                                    text: clinica.nombre + "\n" +
                                        "NIT:" + clinica.nit + "\n" +
                                        clinica.direccion.direccion + "\n"
                                        + clinica.telefono1 + "\n" +
                                        clinica.email
                                },
                            ],
                            alignment: "center"
                        },
                    ],
                },
                { text: 'Reporte Cierre de Recibos de Caja | ' + 'Fecha Inicio: ' + moment(starterDate).format('DD/MM/YYYY') + ' Fecha Final: ' + moment(finalDate).format('DD/MM/YYYY'), style: 'tableheader' },
                {
                    // auto-sized columns have their widths based on their content                                       
                    margin: [0, 0, 0, 10],
                    layout: 'lightHorizontalLines',
                    table: {
                        headerRows: 1,
                        widths: [75, 150, 50, 75, 50, 50, 50, 100, 40, 40, 40,40],
                        body: this.closuresCashBody(data.recibos_caja)
                    },
                },
                {
                    // auto-sized columns have their widths based on their content                                       
                    margin: [0, 20, 0, 10],
                    layout: 'headerLineOnly',
                    table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: this.totalClosureCash(data)
                    },
                },
                {
                    // auto-sized columns have their widths based on their content                                       
                    margin: [0, 20, 0, 10],
                    layout: 'headerLineOnly',
                    table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: this.consolidados(data.recibos_consolidados)
                    },
                }
            ],
            footer: function (currentPage, pageCount) {
                return {
                    table: {
                        widths: ['*', '*', '*'],
                        body: [
                            [{
                                text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'head'
                            },
                            {
                                text: 'Fecha Impresión: ' + moment(new Date()).format('LLLL'), style: 'head'
                            }],
                        ]
                    },
                    layout: 'noBorders',
                    margin: [20, 0, 0, 5],
                };
            }
        };

        pdfMake.createPdf(documentDefinition).open();
    }

    formatNumber = (num) => {
        num = num + ''; // Número a cadena
        var str = ""; // Acumulación de cadenas
        for (var i = num.length - 1, j = 1; i >= 0; i--, j++) {
            if (j % 3 == 0 && i != 0) {// Se agrega una coma cada tres dígitos para filtrar el caso donde es exactamente el primer dígito
                str += num[i] + ","; // Agrega una coma de miles
                continue;
            }
            str += num[i]; // Para acumular números al revés
        }
        return str.split('').reverse().join(""); // String => Array => Reverse => String
    }

    async getStyles() {
        return {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            tableheader: {
                margin: [
                    10,//Izquierda
                    20,//Arriba
                    0,//Derecha
                    0//Abajo
                ],
                fontSize: 12,
                bold: true,
            },
            textStyle: {
                fontSize: 9,
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left'
            },
            foter: {
                alignment: 'center',
                fontSize: 6,
            },
            medicStyle: {
                margin: [0, 80, 0, 0],
                fontSize: 10,
                alignment: 'left',
            },
            textStyle: {
                fontSize: 9,
                font: 'OpenSans'
            },
            textStylePac: {
                fontSize: 10,
                font: 'OpenSans',
                bold: true
            },
            tableheader: {
                fontSize: 11,
                bold: true,
                font: 'OpenSans',
                margin: [0, 20]
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left',
                font: 'OpenSans'
            },
        }
    }

    async getBase64ImageFromURL(url) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.setAttribute("crossOrigin", "anonymous");

            img.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                var dataURL = canvas.toDataURL("image/png");

                resolve(dataURL);
            };

            img.onerror = error => {
                reject(error);
            };

            img.src = url;
        });
    }

    closuresCashBody(recibos_caja) {
        let bodyClosure = [];

        bodyClosure.push(
            [
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Num. Documento', bold: true, style: 'textStyle' },
                { text: 'Nombre Paciente', bold: true, style: 'textStyle' },
                { text: 'Factura', bold: true, style: 'textStyle' },
                { text: 'Fecha Facturación', bold: true, style: 'textStyle' },
                { text: 'Fecha Recibo', bold: true, style: 'textStyle'},
                { text: 'No Recibo', bold: true, style: 'textStyle' },
                { text: 'Admisión', bold: true, style: 'textStyle' },
                { text: 'Cliente', bold: true, style: 'textStyle' },
                { text: 'CUPS', bold: true, style: 'textStyle' },
                { text: 'Subtotal', bold: true, style: 'textStyle' },
                { text: 'Recibo', bold: true, style: 'textStyle' },
                { text: 'Total', bold: true, style: 'textStyle' },
                { text: 'Recibo Anulado', bold: true, style: 'textStyle' },
            ]
        );

        for (var i = 0; i < recibos_caja.length; i++) {
            let num_recibo = recibos_caja[i].num_recibo != "" && recibos_caja[i].num_recibo != null ? recibos_caja[i].num_recibo : "N/a";
            let serviciosText = "";
            for (let k = 0; k < recibos_caja[i].cita_servicios.servicios.length; k++) {
                if (k == 0) {
                    serviciosText = recibos_caja[i].cita_servicios.servicios[k].codigo + '-' + recibos_caja[i].cita_servicios.servicios[k].nombre;
                }
                else {
                    serviciosText = serviciosText + ", " + recibos_caja[i].cita_servicios.servicios[k].codigo + '-' + recibos_caja[i].cita_servicios.servicios[k].nombre;
                }
            }
            let sumSubtotal = parseInt(recibos_caja[i].valor_tercero) + parseInt(recibos_caja[i].total);
            let cant_total = parseInt(recibos_caja[i].total)
            let valor_tercero = parseInt(recibos_caja[i].valor_tercero)
            bodyClosure.push(
                [
                    { text: recibos_caja[i].tipo_documento_paciente + "-" + recibos_caja[i].num_documento_paciente, style: 'textStyle' },
                    { text: recibos_caja[i].nombre_paciente, style: 'textStyle' },
                    { text: recibos_caja[i].num_fac_ter, style: 'textStyle' },
                    { text: recibos_caja[i].fecha_emision != null && recibos_caja[i].fecha_emision != undefined ? moment(recibos_caja[i].fecha_emision).format("DD/MM/YYYY") : "", style: 'textStyle' },
                    { text: recibos_caja[i].fecha != null && recibos_caja[i].fecha != undefined ? moment(recibos_caja[i].fecha).format("DD/MM/YYYY") : "", style: 'textStyle' },
                    { text: num_recibo, style: 'textStyle' },
                    { text: recibos_caja[i].id_admision, style: 'textStyle' },
                    { text: recibos_caja[i].cliente, style: 'textStyle' },
                    { text: serviciosText, style: 'textStyle' },
                    { text: '$' + this.formatNumber(sumSubtotal), style: 'textStyle' },
                    { text: '$' + this.formatNumber(cant_total), style: 'textStyle' },
                    { text: '$' + this.formatNumber(valor_tercero), style: 'textStyle' },
                    { text: recibos_caja[i].recibo_cancelado == true ? "SI" : "NO", style: 'textStyle' },
                ]
            );
        }

        return bodyClosure;
    }

    totalClosureCash(data) {
        let bodyClosure = [];
        bodyClosure.push([
            { text: 'Totales', style: 'tableheader' },
            '',
        ]);

        bodyClosure.push(
            [
                { text: 'Subtotal', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(parseInt(data.total_recibos) + parseInt(data.copago)), bold: true, style: 'textStyle' },
            ]
        );
        /* bodyClosure.push(
            [
                { text: 'Subtotal', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(parseInt(data.subtotal)), bold: true, style: 'textStyle' },
            ]
        ); */
        bodyClosure.push(
            [
                { text: 'Pagos Tarjetas', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(data.total_tarjetas), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Cheques', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(data.total_cheques), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Efectivo', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(data.total_efectivo), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Otros', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(data.total_otros), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Recibidos', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(data.copago), bold: true, style: 'textStyle' },
            ]
        );

        
        bodyClosure.push(
            [
                { text: 'Total Anulado', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(data.total_anulado), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Total Facturado', bold: true, style: 'textStyle' },
                { text: '$' + this.formatNumber(data.total_recibos), bold: true, style: 'textStyle' },
            ]
        );


        return bodyClosure;
    }

    consolidados(data) {
        let bodyConsolidado = [];
        bodyConsolidado.push([
            { text: 'Recibos de Caja Consolidados', style: 'tableheader' },
            '',
        ]);

        bodyConsolidado.push(
            [
                { text: 'Nombre del Cliente', bold: true, style: 'textStyle' },
                { text: "Total del Cliente", bold: true, style: 'textStyle' },
            ]
        );


        for (var i = 0; i < data.length; i++) {
            let total = parseInt(data[i].total)
            bodyConsolidado.push(
                [
                    { text: data[i].cliente, bold: true, style: 'textStyle' },
                    { text: '$' + this.formatNumber(total), bold: true, style: 'textStyle' },
                ]
            );
        }

        return bodyConsolidado;
    }


}


export default new ClosuresOfCashReceiptsPDF();